const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api' || 'https://trainotes.com/';

export const getWorkouts = async (token) => {
  try {
    let response = await fetch(`${API_URL}/user-workouts`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });

    if (response.status === 401) {
      const newToken = await refreshAuthToken();
      if (newToken) {
        response = await fetch(`${API_URL}/user-workouts`, {
          headers: {
            'Authorization': `Bearer ${newToken}`,
          },
          credentials: 'include',
        });
      } else {
        throw new Error('Токен истек и не удалось обновить его');
      }
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при загрузке тренировок: ${response.status}`);
    }
    return await response.json();
  } catch (error) {

    throw error;
  }
};

export const addWorkout = async (workout, token) => {
  try {
    const response = await fetch(`${API_URL}/user-workouts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
      body: JSON.stringify(workout),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при добавлении тренировки: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    
    throw error;
  }
};

export const deleteWorkout = async (workoutId, workout_date, token) => {
  try {
    const response = await fetch(`${API_URL}/user-workouts/${workoutId}?workout_date=${workout_date}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при удалении тренировки: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
   
    throw error;
  }
};

export const copyWorkout = async (source_workout_date, source_workoutId, target_workout_date, token) => {
  try {

    const response = await fetch(`${API_URL}/user-workouts/copy`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
      body: JSON.stringify({ source_workout_date, source_workoutId, target_workout_date }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при копировании тренировки: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    
    throw error;
  }
};

export const getCustomMuscleGroups = async (token) => {
  try {
    const response = await fetch(`${API_URL}/user-muscle-groups`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при загрузке пользовательских групп мышц: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
   
    throw error;
  }
};

export const saveCustomMuscleGroups = async (customMuscleGroups, token) => {
  try {
    const response = await fetch(`${API_URL}/user-muscle-groups`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
      body: JSON.stringify({ muscleGroups: customMuscleGroups }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при сохранении пользовательских групп мышц: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
   
    throw error;
  }
};

export const loginWithTelegram = async (telegramData) => {
  try {
    const response = await fetch(`${API_URL}/telegram-auth`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(telegramData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Ошибка авторизации через Telegram');
    }

    const { accessToken } = await response.json();
    localStorage.setItem('jwt', accessToken);
    window.location.href = `${API_URL}/confirm-cookie`; // Перенаправление для подтверждения куки
    return accessToken;
  } catch (error) {
   
    throw error;
  }
};

export const refreshAuthToken = async () => {
  try {
    /* $& */
    const response = await fetch(`${API_URL}/refresh-token`, {
      method: 'POST',
      credentials: 'include',
    });

    /* $& */
    if (response.ok) {
      const data = await response.json();
      /* $& */
      localStorage.setItem('jwt', data.accessToken);
      return data.accessToken;
    } else {
      
      return null;
    }
  } catch (error) {

    return null;
  }
};

export const sendOtp = async (email, otp) => {
  try {
    const response = await fetch(`${API_URL}/auth/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, otp }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Ошибка при отправке OTP');
    }
    return await response.json();
  } catch (error) {
  
    throw error;
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await fetch(`${API_URL}/auth/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, otp }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Ошибка при проверке OTP');
    }
    const data = await response.json();
    if (data.accessToken) {
      localStorage.setItem('jwt', data.accessToken);
      window.location.href = `${API_URL}/confirm-cookie`; // Перенаправление для подтверждения куки
    }
    return data;
  } catch (error) {
    
    throw error;
  }
};

export const completeRegistration = async (email, name) => {
  try {
    const response = await fetch(`${API_URL}/auth/complete-registration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, name }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Ошибка при завершении регистрации');
    }
    const data = await response.json();
    if (data.accessToken) {
      localStorage.setItem('jwt', data.accessToken);
      window.location.href = `${API_URL}/confirm-cookie`; // Перенаправление для подтверждения куки test 2
    }
    return data;
  } catch (error) {

    throw error;
  }
};

export const getUserInfo = async (token) => {
  try {
    const response = await fetch(`${API_URL}/user-info`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Ошибка при загрузке данных пользователя: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    
    throw error;
  }
}; 

export const getAdminLogs = async (token) => {
  try {
    const response = await fetch(`${API_URL}/admin/logs`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Ошибка при загрузке логов');
    }
    return await response.json();
  } catch (error) {
 
    throw error;
  }
};